<template>
  <b-avatar
    style="height: 60px;width: 60px;-o-object-fit: cover;object-fit: cover;margin-right: 15px;"
    :text="fullname.toUpperCase()"
  />
</template>
<script>
export default {
  props: {
    firstname: {
      type: String
    },
    lastname: {
      type: String
    }
  },
  computed: {
    fullname() {
      if (this.firstname !== undefined && this.lastname !== undefined) {
        return this.lastname.trim()[0] + this.firstname.trim()[0];
      }
      return "";
    }
  }
};
</script>
